
import { Component, Vue } from 'vue-property-decorator';
import { Client, ScheduledJobItemModel, LocationModel} from '@/services/api.service';
import { JobType, EnumModel, JobTypeEnums } from '@/common/enumerations';
import * as DateUtils from '@/utilities/date.utils';
import LocationsMap from '@/components/gis/LocationsMap.vue';

import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';

@Component({
  filters: {
    toJobItemType: toJobItemTypeFormatter
  },
  components: {
    LocationsMap
  }
})
export default class WidgetCurrentDayJobMap extends Vue {

  private locations: LocationModel[] = [];
  private locationsLoaded: boolean = false;
  private mounted() {
    // get the scheduled jobs for today

    let dr = new Date();

    // for my sanity, the '+' unary operator converts string to a number
    const fromDate: number = DateUtils.toIsoDate(dr); 
    dr = DateUtils.addDays(dr, 1);
    const toDate: number = fromDate; // DateUtils.toIsoDate(dr); 

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    
    // Set jobtype to 0 (Mixed) for the search
    clientService.getScheduledJobItems(fromDate, toDate, 0).then((data) => {
      this.locations = [];
      data.forEach((job) => {
        this.locations.push(job.location!);
      });

      this.locationsLoaded = true;
    });
  }
}
